// extracted by mini-css-extract-plugin
export var completionBody = "_jo-2";
export var completionCard = "_jo-0";
export var completionFooter = "_jo-3";
export var completionTitle = "_jo-1";